import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react';
import { apiHolder as api, apis } from 'api';
import classnames from 'classnames';
import IconCard from '@web-common/components/UI/IconCard';
import { useActions, ReadMailActions } from '@web-common/state/createStore';
import styles from './Attachment.module.scss';
import { getIn18Text } from 'api';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { fileApi } from '@web-contact/_mock_';
import { useAppSelector } from '@web-common/state/createStore';
import { useDebounceEffect } from 'ahooks';
import moment from 'moment';
import { formatFileSize } from '@web-common/utils/file';
import { getTrackedUrl } from '@web-common/utils/download_track';
import { isMainAccount } from '@web-mail/util';
import { getAttachControlState, buildAttachPreviewContainerUrl, openAttachPreviewContainer } from '@web-mail/utils/mailAttach';
import { IMG_TYPES } from '@web-mail/common/constant';
import ReadMailDownloadCard from '@web-common/components/UI/ReadMailDownloadCard';
const systemApi = api.api.getSystemApi();
const inElectron = systemApi.isElectron();
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const Attachment = ({ content, readOnly = false, featureConfig, forceUpdate }) => {
    var _a, _b, _c;
    const [attachments, setAttachments] = useState([]);
    const [downLoadIrrevocable, setDownLoadIrrevocable] = useState(false);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const [attachmentsZipPath, setAttachmentsZipPath] = useState('');
    const [icsSuccess, setIcsSuccess] = useState(true);
    const [totalSize, setTotalSize] = useState('');
    const [attachmentsHeight, setAttachmentsHeight] = useState(0);
    const [attachmentFlod, setAttachmentFlod] = useState(false);
    const [icsMail, setIcsMail] = useState(false);
    const setAttachmentsZipPathRef = useRef('');
    setAttachmentsZipPathRef.current = attachmentsZipPath;
    const isTpMail = useMemo(() => !!(content === null || content === void 0 ? void 0 : content.isTpMail), [content]);
    const isDecrypted = useMemo(() => !!(content === null || content === void 0 ? void 0 : content.isDecrypted), [content]);
    const isEncryptedMail = useMemo(() => !!(content === null || content === void 0 ? void 0 : content.isEncryptedMail), [content]);
    const attachmentsRef = useRef(null);
    const [firstAttach, setFirstAttach] = useState({ name: '', suffix: '' });
    const [icsProps, setIcsProps] = useState({
        mid: '0',
        attachmentsIds: [],
        senderEmail: '',
        setIcsSuccess,
    });
    const attactCardConfig = useMemo(() => {
        return featureConfig === null || featureConfig === void 0 ? void 0 : featureConfig.attachCard;
    }, [featureConfig]);
    useEffect(() => {
        const element = attachmentsRef.current;
        if (!element)
            return;
        const resizeOb = new ResizeObserver(() => {
            setAttachmentsHeight(element.scrollHeight);
        });
        resizeOb.observe(element);
        return () => {
            resizeOb.disconnect();
        };
    }, []);
    const revolveDownloadReminder = (reminders) => {
        const manageReminders = reminders.map(item => {
            if (item.filePath) {
                const realFileName = window.electronLib.fsManage.getBaseName(item.filePath);
                if (realFileName) {
                    return Object.assign(Object.assign({}, item), { realFileName });
                }
            }
            return item;
        });
        systemApi.createWindowWithInitData('downloadReminder', {
            eventName: 'customNotification',
            eventData: {
                eventType: 'downloadReminder',
                reminders: manageReminders,
            },
        });
    };
    const dealAttachments = (list, downloadContentId, senderEmail) => {
        const icsList = list.filter(attachment => attachment.fileType === 'ics');
        const normalAttachCount = list.filter(e => e.fileType !== 'ics');
        let category;
        if (icsList.length) {
            setIcsProps({
                senderEmail,
                mid: downloadContentId,
                setIcsSuccess,
                attachmentsIds: icsList.map(item => item.id),
            });
            setIcsMail(true);
            setIcsSuccess(true);
            category = getIn18Text('DAIicsFU');
        }
        else {
            setIcsMail(false);
            category = normalAttachCount && normalAttachCount.length > 0 ? getIn18Text('DAIFEIics') : getIn18Text('BUDAIPUTONGFU');
        }
        trackApi.track('pcMail_view_mailDetailPage', { category });
    };
    const isMainAcc = useMemo(() => {
        return isMainAccount(content === null || content === void 0 ? void 0 : content._account);
    }, [content]);
    const [attachControl, setAttachControl] = useState({ isMainAccount: false, previewEnabled: false, downloadBanned: false });
    useEffect(() => {
        let alive = true;
        getAttachControlState(content === null || content === void 0 ? void 0 : content._account, { isTpMail: !!(content === null || content === void 0 ? void 0 : content.isTpMail) }).then(res => {
            if (alive)
                setAttachControl(res);
        });
        return () => {
            alive = false;
        };
    }, [content === null || content === void 0 ? void 0 : content._account, content === null || content === void 0 ? void 0 : content.isTpMail]);
    const fromLocalEml = useMemo(() => !!(content === null || content === void 0 ? void 0 : content.localFilePath), [content]);
    const attachmentInlinedKey = useMemo(() => {
        var _a, _b;
        if (content && ((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.attachment)) {
            let key = '';
            (_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.attachment.forEach(item => {
                key += (item === null || item === void 0 ? void 0 : item.inlined) + ',';
            });
            return key;
        }
        return '';
    }, [content]);
    const { updateScrollToAttachments } = useActions(ReadMailActions);
    useEffect(() => {
        if (!content) {
            return;
        }
        const list = content.entry.attachment;
        if (list && list.length) {
            const filterList = list
                .filter(item => !item.inlined)
                .map(item => (Object.assign(Object.assign({}, item), { type: 'download', cloudAttachment: item.type === 'netfolder', downloadId: item.id + ';' + content.id, downloadContentId: content.id, size: item.fileSize, mailId: content.id, unDecrypted: content.isEncryptedMail && !content.isDecrypted })));
            if (content.isDecrypted) {
                setAttachments([]);
                setTimeout(() => {
                    setAttachments(() => {
                        if (icsSuccess) {
                            return filterList.filter(item => item.fileType !== 'ics');
                        }
                        return filterList;
                    });
                }, 200);
            }
            else {
                setAttachments(() => {
                    if (icsSuccess) {
                        return filterList.filter(item => item.fileType !== 'ics');
                    }
                    return filterList;
                });
            }
            const listSize = filterList
                .filter(item => item.fileType !== 'ics')
                .reduce((total, current) => {
                total += current.size;
                return total;
            }, 0);
            setTotalSize(listSize > 0 ? formatFileSize(listSize, 1024) : '');
            setAttachmentFlod(false);
        }
        else {
            setTotalSize('');
            setAttachments(data => {
                if (data && data.length == 0) {
                    return data;
                }
                return [];
            });
        }
    }, [icsSuccess, attachmentInlinedKey, content === null || content === void 0 ? void 0 : content.id, (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.attachment, content === null || content === void 0 ? void 0 : content.isDecrypted]);
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (content && (content === null || content === void 0 ? void 0 : content.id) && (content === null || content === void 0 ? void 0 : content.entry)) {
            if ((_b = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.attachment) === null || _b === void 0 ? void 0 : _b.length) {
                dealAttachments((_c = content === null || content === void 0 ? void 0 : content.entry) === null || _c === void 0 ? void 0 : _c.attachment, content === null || content === void 0 ? void 0 : content.id, (_e = (_d = content === null || content === void 0 ? void 0 : content.sender) === null || _d === void 0 ? void 0 : _d.contactItem) === null || _e === void 0 ? void 0 : _e.contactItemVal);
            }
            else {
                setIcsMail(false);
                trackApi.track('pcMail_view_mailDetailPage', { category: getIn18Text('BUDAIPUTONGFU') || '' });
            }
        }
    }, [content === null || content === void 0 ? void 0 : content.id, (_c = (_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.attachment) === null || _c === void 0 ? void 0 : _c.length, forceUpdate]);
    const getName = (fileName) => {
        const nameSplit = fileName.split('.');
        const suffix = nameSplit.pop();
        setFirstAttach({
            name: nameSplit.join('.'),
            suffix: `${suffix}`,
        });
    };
    const notExpired = (expireTime) => {
        return expireTime == null || expireTime === 0 || expireTime > Date.now();
    };
    const saveAttachmentZip = useCallback(async () => {
        var _a;
        const _attachments = attachments.filter(attachment => notExpired(attachment.expired));
        if (_attachments.length === 0) {
            return;
        }
        const currDayStr = moment().format('YYYYMMDD');
        let mailName = '-';
        try {
            const title = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.title;
            if (title) {
                mailName = title.replace(/[:*\^\|'"`~]/gi, '_');
            }
        }
        catch (e) {
            console.error('[Error reg]', e);
        }
        const zipFileName = isCorpMail
            ?
                `Attachments-${currDayStr}`
            : `${mailName}的全部附件${currDayStr}`;
        if (inElectron) {
            if (downLoadIrrevocable)
                return;
            setDownLoadIrrevocable(true);
            try {
                const zipRes = await fileApi.saveZip(_attachments, zipFileName, content === null || content === void 0 ? void 0 : content.id, {
                    removeOrginalFile: true,
                    flowScene: 'mail_read',
                    _account: content === null || content === void 0 ? void 0 : content._account,
                });
                console.log('saveAttachmentZip 打包下载', zipRes);
                const { success, path } = zipRes;
                if (success && path) {
                    setAttachmentsZipPath(path);
                    try {
                        const zipData = await window.electronLib.fsManage.stat(path);
                        if (zipData) {
                            revolveDownloadReminder([
                                {
                                    fileName: `${zipFileName}.zip`,
                                    fileSize: zipData.size,
                                    fileType: 'zip',
                                    filePath: path,
                                },
                            ]);
                        }
                    }
                    catch (err) {
                        console.log('打包下载完成提醒失败', err);
                    }
                }
            }
            catch (e) {
                console.error(e);
                SiriusMessage.warn({ content: getIn18Text('DABAOXIAZAISHI') });
            }
            finally {
                setDownLoadIrrevocable(false);
            }
        }
        else {
            const url = mailConfApi.getReadMailPackUrl(content, attachments, zipFileName);
            if (url) {
                const trackedUrl = getTrackedUrl(url);
                if (window.isInOtherApp) {
                    fileApi.saveDownloadInOtherApp({ fileName: `${zipFileName}.zip`, fileUrl: trackedUrl || url });
                }
                else {
                    window.open(trackedUrl || url);
                }
            }
        }
    }, [isCorpMail, downLoadIrrevocable, content, attachments]);
    useDebounceEffect(() => {
        if (!(content === null || content === void 0 ? void 0 : content.id)) {
            return;
        }
        fileApi.getAttachmentZipPath(content === null || content === void 0 ? void 0 : content.id).then(result => {
            if (result) {
                setAttachmentsZipPath(result);
            }
            else {
                setAttachmentsZipPath('');
            }
        });
    }, [content === null || content === void 0 ? void 0 : content.id], { wait: 500 });
    const saveAllAttachment = useCallback(async (_account) => {
        const _attachments = attachments.filter(attachment => notExpired(attachment.expired));
        if (_attachments.length === 0) {
            return;
        }
        if (downLoadIrrevocable) {
            return;
        }
        setDownLoadIrrevocable(true);
        try {
            const downloadRes = await fileApi.saveAll(_attachments, _account);
            console.log('saveAllAttachment 分别下载', downloadRes);
            const { success, loadResArr } = downloadRes;
            if (success && loadResArr) {
                let sucFileModel = [];
                loadResArr.forEach(item => {
                    const { succ, fileModel } = item;
                    if (succ && (fileModel === null || fileModel === void 0 ? void 0 : fileModel.filePath)) {
                        sucFileModel.push(fileModel);
                    }
                });
                (sucFileModel === null || sucFileModel === void 0 ? void 0 : sucFileModel.length) && revolveDownloadReminder(sucFileModel);
            }
        }
        catch (e) {
            console.error(e);
            SiriusMessage.warn({ content: getIn18Text('FENBIEXIAZAISHI') });
        }
        finally {
            setDownLoadIrrevocable(false);
        }
    }, [isCorpMail, downLoadIrrevocable, content, attachments]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.readmailAttachments, onClick: e => {
                e === null || e === void 0 ? void 0 : e.stopPropagation();
            }, hidden: !attachments.length },
            React.createElement("div", { className: styles.title },
                React.createElement(ReadListIcons.AttachPinSvg, null),
                React.createElement("span", { style: { marginLeft: '4px' } },
                    attachments.length,
                    getIn18Text('GEFUJIAN')),
                totalSize && React.createElement("span", null,
                    "\u00A0|\u00A0",
                    totalSize),
                attachments.length > 2 && attachmentsHeight > 65 && (React.createElement("div", { className: styles.attachmentArrow, onClick: () => {
                        setAttachmentFlod(pre => !pre);
                    } },
                    React.createElement(IconCard, { type: attachmentFlod ? 'arrowDown' : 'arrowUp' }))),
                !fromLocalEml && attachments.length > 1 && inElectron && !(attactCardConfig === null || attactCardConfig === void 0 ? void 0 : attactCardConfig.hidePackDownload) && !attachControl.downloadBanned && (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: styles.saveAllInApp, onClick: () => saveAttachmentZip() }, getIn18Text('DABAOXIAZAI')),
                    React.createElement("span", { className: styles.saveAllInApp, onClick: () => saveAllAttachment(content === null || content === void 0 ? void 0 : content._account) }, getIn18Text('FENBIEXIAZAI')))),
                !fromLocalEml &&
                    attachments.length > 1 &&
                    !inElectron &&
                    !(attactCardConfig === null || attactCardConfig === void 0 ? void 0 : attactCardConfig.hidePackDownload) &&
                    !attachControl.downloadBanned &&
                    attachments.every(item => {
                        return item.cloudAttachment !== true;
                    }) && (React.createElement("span", { className: styles.saveAll, onClick: () => saveAttachmentZip() }, getIn18Text('DABAOXIAZAI')))),
            React.createElement("div", { className: classnames(styles.attachmentList, attachmentFlod && styles.attachmentFlod), ref: attachmentsRef }, (attachments === null || attachments === void 0 ? void 0 : attachments.length) && (React.createElement(React.Fragment, null,
                attachments.map((item, idx) => {
                    var _a, _b;
                    const isImageAtt = !!item.fileType && IMG_TYPES.includes(item.fileType);
                    const isCloudAtt = item.cloudAttachment === true || item.type === 'netfolder';
                    const isEncryptedAtt = !!(content === null || content === void 0 ? void 0 : content.isEncryptedMail) || (item === null || item === void 0 ? void 0 : item.fileType) === 'cmecypt';
                    const isNormalDoc = !isImageAtt && !isCloudAtt && !isEncryptedAtt;
                    let itemCardConfig = attactCardConfig;
                    if (attachControl.downloadBanned) {
                        if (isEncryptedAtt) {
                            itemCardConfig = Object.assign(Object.assign({}, attactCardConfig), { hideCloudPreview: true, hideSaveForward: true, hideForward: true, hideCopy: true, hideSafeBrowsing: true });
                        }
                        else if (isNormalDoc || isImageAtt) {
                            itemCardConfig = Object.assign(Object.assign({}, attactCardConfig), { hideDownload: true, hideActionOperate: true, hideSaveForward: true, hideForward: true, hideCopy: true, hideSafeBrowsing: true });
                        }
                    }
                    const previewOpener = attachControl.previewEnabled && isNormalDoc
                        ? () => openAttachPreviewContainer(buildAttachPreviewContainerUrl({ mailId: content.id, partId: item.id, account: content === null || content === void 0 ? void 0 : content._account }))
                        : undefined;
                    const cardElemnt = (React.createElement(ReadMailDownloadCard, { from: "mail", className: styles.card, idx: idx, id: item.downloadId, mid: content === null || content === void 0 ? void 0 : content.id, fid: (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.folder, downloadInfo: item, attachments: attachments, irrevocable: downLoadIrrevocable, showCloudPreview: (isTpMail || !readOnly) && !['cmecypt'].includes((item === null || item === void 0 ? void 0 : item.fileType) || '') && !(content === null || content === void 0 ? void 0 : content.isEncryptedMail), showSaveForward: !readOnly && isMainAcc && !(isEncryptedMail && !isDecrypted), attactCardConfig: itemCardConfig, isTpMail: !!content.isTpMail, source: fromLocalEml ? 'eml' : '', _account: content === null || content === void 0 ? void 0 : content._account, mailSubject: (_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.title, openPreviewContainer: previewOpener, downloadBanned: attachControl.downloadBanned && isImageAtt }));
                    return cardElemnt;
                }),
                Array(10)
                    .fill(null)
                    .map((_, index) => (React.createElement("div", { key: `f${index}`, className: styles.placeholder })))))))));
};
export default Attachment;
